import { combineReducers } from '@reduxjs/toolkit';
import { AppThunkApi, AppThunkApiConfig, PdpDispatch, PdpState, PdpStore, PdpThunk } from '@ff-os/pdp-shared-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { reducer as groups } from './slices/groupsSlice';
import { reducer as photos } from './slices/photosSlice';
import { reducer as ui } from './slices/uiSlice';
import { reducer as version } from './slices/versionSlice';

const projectReducers = {
    version,
    groups,
    photos
};

export const photoPrintsPluginReducers = {
    ui: ui,
    project: combineReducers(projectReducers)
};

export type PhotoPrintsPdpStore = PdpStore<PhotoPrintsJson.Project>;
export type PhotoPrintsPdpDispatch = PdpDispatch<PhotoPrintsJson.Project>;
export type PhotoPrintsPdpState = PdpState<PhotoPrintsJson.Project>;
export type PhotoPrintsPdpThunk<ReturnType = void> = PdpThunk<PhotoPrintsJson.Project, ReturnType>;
export type PhotoPrintsThunkApi = AppThunkApi<PhotoPrintsJson.Project>;
export type PhotoPrintsThunkApiConfig = AppThunkApiConfig<PhotoPrintsJson.Project>;